import { MIRRORING_PAGENAME } from '../../routes/mirroring/constant';

const LS_KEYS = {
  TP_RESTORE_FLAG: 'tp_restore_flag', // reconnect to websocket after refreshing browser when the value is true
  TP_PAGE_NAME: MIRRORING_PAGENAME.LOGIN,
  TP_WS_PULL: 'tp_ws_pull',
  TP_ROOM_ID: 'tp_room_id',
  TP_REDUX_STATE_TREE: 'tp_redux_state_tree',
};

const get = (key, shouldParse = true) => {
  const data = sessionStorage.getItem(key);
  if (shouldParse === true) {
    return JSON.parse(data);
  }
  if (typeof shouldParse === 'function') {
    return shouldParse(data);
  }
  return data;
};

const set = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify(value));
};

const del = key => {
  sessionStorage.removeItem(key);
};

export default {
  get,
  set,
  del,
  LS_KEYS,
};
